/* eslint-disable no-unused-vars */
const getAbilityLevel = require('../../isomorphic-helpers/getAbilityLevel');

const AbilityFuncs = {
  // Standard
  move: {
    range: function (level, atts, unit) {
      return { min: 1, max: 1 };
    },
    apCost: function (level, atts, unit) {
      return 20;
    },
  },

  melee_attack: {
    range: function (level, atts, unit) {
      return { min: 1, max: 1 };
    },
    apCost: function (level, atts, unit) {
      return Math.round(Math.max(20, 45 - atts.dexterity / 4));
    },
    damage: function (level, atts, unit) {
      return Math.round(atts.meleeDamage);
    },
  },

  // Alchemy
  poison_weapon: {
    range: function (level, atts, unit) {
      return { min: 0, max: 1 };
    },
    apCost: function (level, atts, unit) {
      return 30 - level;
    },
    mpCost: function (level, atts, unit) {
      return 5 + level * 4;
    },
    potency: function (level, atts, unit) {
      return Math.round(20 + level * (atts.learning / 5));
    },
    charges: function (level, atts, unit) {
      return Math.round(level + atts.dexterity / 4);
    },
  },
  burning_hands: {
    range: function (level, atts, unit) {
      return { min: 1, max: 1 };
    },
    apCost: function (level, atts, unit) {
      return 40 - level;
    },
    mpCost: function (level, atts, unit) {
      return 5 + level * 4;
    },
    damage: function (level, atts, unit) {
      return Math.round(
        65 + level * (atts.learning / 2 + atts.mana / 4 + atts.dexterity / 6)
      );
    },
  },
  molotov_cocktail: {
    range: function (level, atts, unit) {
      return { min: 0, max: 3 + level / 2 };
    },
    apCost: function (level, atts, unit) {
      return Math.max(70 - level * 2, 1);
    },
    mpCost: function (level, atts, unit) {
      return 20 + level * 4;
    },
    damage: function (level, atts, unit) {
      return Math.round(40 + level * (atts.learning / 2 + atts.dexterity / 6));
    },
    effectRange: () => 3, // (reduced by 25% per distance from center)
  },
  ice_nine: {
    range: function (level, atts, unit) {
      return { min: 0, max: 3 };
    },
    apCost: function (level, atts, unit) {
      return 15;
    },
    mpCost: function (level, atts, unit) {
      return 20 + level * 2;
    },
    charges: function (level, atts, unit) {
      return level;
    },
    duration: function (level, atts, unit) {
      return Math.round(2000 + 1000 * level * (atts.learning / 80));
    },
  },
  fumigate: {
    range: function (level, atts, unit) {
      return { min: 0, max: 4 }; // cheating for AI logic to treat this as a ranged ability
    },
    effectRange: function (level, atts, unit) {
      return 4;
    },
    apCost: function (level, atts, unit) {
      return 50 - level;
    },
    mpCost: function (level, atts, unit) {
      return 40 + level * 4;
    },
    potency: function (level, atts, unit) {
      return Math.round(10 + level * (atts.learning / 6 + atts.mana / 10));
    },
  },
  lightning: {
    range: function (level, atts, unit) {
      return { min: 1, max: 2 };
    },
    apCost: function (level, atts, unit) {
      return 40 - level;
    },
    mpCost: function (level, atts, unit) {
      return 30 + level * 3;
    },
    damage: function (level, atts, unit) {
      return Math.round(100 + level * (atts.learning / 7 + atts.mana / 7));
    },
  },
  road_to_nowhere: {
    range: function (level, atts, unit) {
      return { min: 0, max: 3 };
    },
    apCost: function (level, atts, unit) {
      return 50;
    },
    mpCost: function (level, atts, unit) {
      return 20 + level;
    },
    duration: function (level, atts, unit) {
      return Math.round(
        1000 + 1000 * level * (atts.learning / 150 + atts.perception / 200)
      );
    },
  },

  // Armor Use
  layers_of_protection: {
    potency: function (level, atts, unit) {
      return level * 5;
    },
  },
  shield_block: {
    range: function (level, atts, unit) {
      return { min: 0, max: 0 };
    },
    apCost: function (level, atts, unit) {
      return Math.max(35 - level, 1);
    },
    duration: function (level, atts, unit) {
      return Math.round(500 + 1000 * level * (atts.strength / 250));
    },
  },
  bash: {
    range: function (level, atts, unit) {
      return { min: 1, max: 1 };
    },
    apCost: function (level, atts, unit) {
      return Math.max(50 - level * 2, 1);
    },
    damage: function (level, atts, unit) {
      return Math.round(level * (atts.strength / 6 + atts.toughness / 10));
    },
    duration: function (level, atts, unit) {
      return Math.round(
        1000 + 1000 * level * (atts.strength / 200 + atts.dexterity / 300)
      );
    },
  },
  suture: {
    range: function (level, atts, unit) {
      return { min: 0, max: 1 };
    },
    apCost: function (level, atts, unit) {
      return Math.max(65 - level * 2, 1);
    },
    healing: function (level, atts, unit) {
      return Math.round(10 + level * (atts.learning / 8 + atts.mana / 10));
    },
    potency: function (level, atts, unit) {
      return Math.round(20 + level * (atts.learning + atts.dexterity));
    },
  },
  missile_defense: {
    potency: function (level, atts, unit) {
      return level * 0.05;
    },
  },
  armor_spikes: {
    potency: function (level, atts, unit) {
      return level * 0.03;
    },
  },
  reflect_magic: {
    potency: function (level, atts, unit) {
      return level * 0.02;
    },
  },

  // Bow Use
  arrow_shot: {
    range: function (level, atts, unit_build) {
      return {
        min: 2,
        max:
          4 +
          getAbilityLevel({
            unit_build,
            tree_handle: 'bow_use',
            ability_handle: 'range',
          }),
      };
    },
    apCost: function (level, atts, unit) {
      return Math.max(50 - level * 2, 1);
    },
    damage: function (level, atts, unit) {
      return Math.round(
        65 +
          level *
            (atts.perception / 8 + atts.dexterity / 10 + atts.learning / 12)
      );
    },
  },
  range: {
    potency: function (level, atts, unit) {
      return level;
    },
  },
  leg_shot: {
    range: function (level, atts, unit_build) {
      return {
        min: 2,
        max:
          4 +
          getAbilityLevel({
            unit_build,
            tree_handle: 'bow_use',
            ability_handle: 'range',
          }),
      };
    },
    apCost: function (level, atts, unit) {
      return Math.max(50 - level * 2, 1);
    },
    damage: function (level, atts, unit) {
      return Math.round(level * (atts.perception / 6 + atts.dexterity / 10));
    },
    duration: function (level, atts, unit) {
      return Math.round(
        1000 + 1000 * level * (atts.perception / 150 + atts.dexterity / 250)
      );
    },
  },
  razor_shot: {
    range: function (level, atts, unit_build) {
      return {
        min: 2,
        max:
          4 +
          getAbilityLevel({
            unit_build,
            tree_handle: 'bow_use',
            ability_handle: 'range',
          }),
      };
    },
    apCost: function (level, atts, unit) {
      return Math.max(50 - level * 2, 1);
    },
    damage: function (level, atts, unit) {
      return Math.round(level * (atts.dexterity / 10));
    },
    potency: function (level, atts, unit) {
      return Math.round(
        15 + level * (atts.perception / 40 + atts.dexterity / 40)
      );
    },
  },
  blunt_arrow: {
    range: function (level, atts, unit_build) {
      return {
        min: 2,
        max:
          4 +
          getAbilityLevel({
            unit_build,
            tree_handle: 'bow_use',
            ability_handle: 'range',
          }),
      };
    },
    apCost: function (level, atts, unit) {
      return Math.max(80 - level * 2, 1);
    },
    damage: function (level, atts, unit) {
      return Math.round(level * (atts.perception / 6 + atts.dexterity / 10));
    },
    duration: function (level, atts, unit) {
      return Math.round(
        500 + 1000 * level * (atts.perception / 250 + atts.dexterity / 350)
      );
    },
  },
  chain_pull: {
    range: function (level, atts, unit_build) {
      return {
        min: 2,
        max:
          4 +
          getAbilityLevel({
            unit_build,
            tree_handle: 'bow_use',
            ability_handle: 'range',
          }),
      };
    },
    apCost: function (level, atts, unit) {
      return Math.max(70 - level * 2, 1);
    },
    damage: function (level, atts, unit) {
      return Math.round(level * (atts.perception / 6 + atts.dexterity / 10));
    },
    potency: function (level, atts, unit) {
      return Math.round(1 + (level * atts.strength) / 120);
    },
  },
  multi_shot: {
    range: function (level, atts, unit_build) {
      return {
        min: 2,
        max:
          4 +
          getAbilityLevel({
            unit_build,
            tree_handle: 'bow_use',
            ability_handle: 'range',
          }),
      };
    },
    apCost: function (level, atts, unit) {
      return Math.max(70 - level * 2, 1);
    },
    charges: function (level, atts, unit) {
      return 2 + level / 2;
    },
    damage: function (level, atts, unit) {
      return Math.round(
        20 +
          level *
            (atts.perception / 12 + atts.dexterity / 14 + atts.learning / 16)
      );
    },
  },

  // Conjuration
  void_spike: {
    range: function (level, atts, unit) {
      return { min: 0, max: Math.floor(4 + level / 2) };
    },
    apCost: function (level, atts, unit) {
      return 35 - level;
    },
    mpCost: function (level, atts, unit) {
      return 5 + level * 4;
    },
    damage: function (level, atts, unit) {
      return Math.round(
        65 + level * (atts.mana / 8 + atts.learning / 10 + atts.perception / 12)
      );
    },
  },
  summon_dwarf: {
    range: function (level, atts, unit) {
      return { min: 1, max: 5 };
    },
    apCost: function (level, atts, unit) {
      return 35;
    },
    mpCost: function (level, atts, unit) {
      return 150 + level * 25;
    },
    potency: function (level, atts, unit) {
      return Math.max(level / 2, 1);
    },
    charges: function (level, atts, unit) {
      return Math.min(5, level + 1);
    },
    duration: function (level, atts, unit) {
      return 40000 + level * 5000;
    },
  },
  summon_elf: {
    range: function (level, atts, unit) {
      return { min: 1, max: 5 };
    },
    apCost: function (level, atts, unit) {
      return 35;
    },
    mpCost: function (level, atts, unit) {
      return 150 + level * 25;
    },
    potency: function (level, atts, unit) {
      return Math.max(level / 2, 1);
    },
    charges: function (level, atts, unit) {
      return Math.min(5, level + 1);
    },
    duration: function (level, atts, unit) {
      return 40000 + level * 5000;
    },
  },
  summon_faerie: {
    range: function (level, atts, unit) {
      return { min: 1, max: 5 };
    },
    apCost: function (level, atts, unit) {
      return 35;
    },
    mpCost: function (level, atts, unit) {
      return 150 + level * 25;
    },
    potency: function (level, atts, unit) {
      return Math.max(level / 2, 1);
    },
    charges: function (level, atts, unit) {
      return Math.min(5, level + 1);
    },
    duration: function (level, atts, unit) {
      return 40000 + level * 5000;
    },
  },
  summon_option: {
    range: function (level, atts, unit) {
      return { min: 0, max: 9 };
    },
    apCost: function (level, atts, unit) {
      return 25;
    },
    mpCost: function (level, atts, unit) {
      return 10 + level * 3;
    },
    damage: function (level, atts, unit) {
      return Math.round(65 + level * (atts.learning / 10 + atts.mana / 10));
    },
    charges: function (level, atts, unit) {
      return Math.round(3 + level);
    },
  },
  mana_node: {
    maBonus: function (level, atts, unit) {
      return level * 0.02;
    },
    mgBonus: function (level, atts, unit) {
      return level / 3;
    },
  },
  teleport: {
    range: function (level, atts, unit) {
      return { min: 1, max: 2 + level / 2 };
    },
    hpCost: function (level, atts, unit) {
      const baseCost = unit.max_hp * 0.12;

      return Math.round(Math.max(baseCost - level * unit.max_hp * 0.01, 1));
    },
    mpCost: function (level, atts, unit) {
      var costsByDist = [];
      var range = AbilityFuncs.teleport.range(level, atts, unit);
      for (var i = range.min; i <= range.max; ++i) {
        costsByDist.push(i * 15);
      }
      return costsByDist;
    },
    apCost: function (level, atts, unit) {
      return 10;
    },
  },

  // Illusion
  sleight_of_hand: {
    range: function (level, atts, unit) {
      return { min: 1, max: 2 + level };
    },
    apCost: function (level, atts, unit) {
      return Math.max(40 - level * 2, 1);
    },
    mpCost: function (level, atts, unit) {
      return 20 + level * 2;
    },
    potency: function (level, atts, unit) {
      return Math.round(100 + level * (atts.mana / 2 + atts.dexterity / 4));
    },
  },

  angel_mask: {
    effectRange: function (level, atts, unit) {
      return 2;
    },
    potency: function (level, atts, unit) {
      return 2 + level;
    },
  },

  psyche_out: {
    range: function (level, atts, unit) {
      return { min: 1, max: Math.floor(3 + level / 3) };
    },
    apCost: function (level, atts, unit) {
      return 35;
    },
    mpCost: function (level, atts, unit) {
      return 20 + level * 2;
    },
    effectRange: function (level, atts, unit) {
      return 1;
    },
    duration: function (level, atts, unit) {
      return Math.round(
        500 + 1000 * level * (atts.willpower / 250 + atts.perception / 350)
      );
    },
  },

  infect_mind: {
    range: function (level, atts, unit) {
      return { min: 0, max: 2 + level };
    },
    apCost: function (level, atts, unit) {
      return 30;
    },
    mpCost: function (level, atts, unit) {
      return 20 + level * 5;
    },
    potency: function (level, atts, unit) {
      return Math.round(15 + level * (atts.learning / 40 + atts.mana / 40));
    },
  },

  devil_mask: {
    range: function (level, atts, unit) {
      return { min: 0, max: 0 };
    },
    apCost: function (level, atts, unit) {
      return 50;
    },
    mpCost: function (level, atts, unit) {
      return 30 + level * 5;
    },
    effectRange: function (level, atts, unit) {
      return 2;
    },
    duration: function (level, atts, unit) {
      return Math.round(
        500 + 1000 * level * (atts.mana / 333 + atts.learning / 333)
      );
    },
  },
  blurred_form: {
    potency: function (level, atts, unit) {
      return level * 0.01;
    },
  },
  faux_self: {
    range: function (level, atts, unit) {
      return { min: 0, max: 0 };
    },
    apCost: function (level, atts, unit) {
      return 35;
    },
    mpCost: function (level, atts, unit) {
      return 40 + level * 5;
    },
    potency: function (level, atts, unit) {
      return Math.max(level / 2, 1);
    },
    charges: function (level, atts, unit) {
      return Math.min(5, level + 1);
    },
    duration: function (level, atts, unit) {
      return 50000 + 3000 * level;
    },
  },

  // Melee Combat
  slash: {
    range: function (level, atts, unit) {
      return { min: 1, max: 1 };
    },
    apCost: function (level, atts, unit) {
      return Math.max(65 - level * 2, 1);
    },
    damage: function (level, atts, unit) {
      return Math.round(level * (atts.strength / 8));
    },
    potency: function (level, atts, unit) {
      return Math.round(
        20 + level * (atts.dexterity / 24 + atts.learning / 50)
      );
    },
  },
  slam: {
    range: function (level, atts, unit) {
      return { min: 1, max: 1 };
    },
    apCost: function (level, atts, unit) {
      return Math.max(45 - level * 2, 1);
    },
    damage: function (level, atts, unit) {
      return Math.round(level * (atts.strength / 6 + atts.dexterity / 10));
    },
    potency: function (level, atts, unit) {
      return Math.round(1 + (level * atts.strength) / 120);
    },
  },
  taunt: {
    range: function (level, atts, unit) {
      return { min: 1, max: 6 };
    },
    apCost: function (level, atts, unit) {
      return Math.max(35 - level, 1);
    },
    mpCost: function (level, atts, unit) {
      return 5 + level;
    },
    duration: function (level, atts, unit) {
      return Math.round(
        1000 + 1000 * level * (atts.willpower / 225 + atts.perception / 275)
      );
    },
  },
  armor_break: {
    range: function (level, atts, unit) {
      return { min: 1, max: 1 };
    },
    apCost: function (level, atts, unit) {
      return Math.max(45 - level * 2, 1);
    },
    potency: function (level, atts, unit) {
      return Math.round(
        10 + level * (atts.strength / 12 + atts.dexterity / 15)
      );
    },
  },
  roundhouse: {
    range: function (level, atts, unit) {
      return { min: 0, max: 0 };
    },
    apCost: function (level, atts, unit) {
      return Math.max(70 - level, 1);
    },
    effectRange: function (level, atts, unit) {
      return 1;
    },
    damage: function (level, atts, unit) {
      return Math.round(60 + level * (atts.dexterity / 3 + atts.strength / 4));
    },
  },
  mortal_strike: {
    range: function (level, atts, unit) {
      return { min: 1, max: 1 };
    },
    apCost: function (level, atts, unit) {
      return Math.max(90 - level, 1);
    },
    damage: function (level, atts, unit) {
      return Math.round(
        120 +
          level * (atts.strength / 2 + atts.dexterity / 3 + atts.willpower / 6)
      );
    },
  },
  sky_hammer: {
    range: function (level, atts, unit) {
      return { min: 0, max: 2 };
    },
    apCost: function (level, atts, unit) {
      return Math.max(80 - level, 1);
    },
    effectRange: function (level, atts, unit) {
      return 2;
    },
    damage: function (level, atts, unit) {
      return Math.round(20 + level * (atts.strength / 8 + atts.dexterity / 10));
    },
    potency: function (level, atts, unit) {
      return Math.floor(1 + level / 3);
    },
  },

  // Movement
  quickness: {
    potency: function (level, atts, unit) {
      return level / 3;
    },
  },

  adrenaline: {
    range: function (level, atts, unit) {
      return { min: 0, max: 0 };
    },
    mpCost: function (level, atts, unit) {
      return 150 - level * 3;
    },
    potency: function (level, atts, unit) {
      return Math.round(10 + level * (atts.strength / 12));
    },
  },
  leap: {
    range: function (level, atts, unit) {
      return { min: 1, max: Math.floor(2 + level / 2) };
    },
    apCost: function (level, atts, unit) {
      const costsByDist = [];
      const range = AbilityFuncs.leap.range(level, atts, unit);
      for (let i = range.min; i <= range.max; ++i) {
        costsByDist.push(Math.ceil(i * (unit.max_ap / range.max)));
      }
      return costsByDist;
    },
  },
  stance_dancing: {
    range: function (level, atts, unit) {
      return { min: 0, max: 0 };
    },
    apCost: function (level, atts, unit) {
      return 50;
    },
    potency: function (level, atts, unit) {
      return level * 0.03;
    },
  },
  tussle: {
    range: function (level, atts, unit) {
      return { min: 1, max: 1 };
    },
    apCost: function (level, atts, unit) {
      return Math.round(Math.max(80 - level * 3 - atts.dexterity / 4, 1));
    },
    damage: function (level, atts, unit) {
      return Math.round(
        30 +
          level * (atts.strength / 6 + atts.dexterity / 8 + atts.learning / 12)
      );
    },
  },
  freedom: {
    potency: function (level, atts, unit) {
      return level * 0.03;
    },
  },
  preparation: {
    potency: function (level, atts, unit) {
      return level * 2;
    },
  },

  // Spirit
  healing_prayer: {
    range: function (level, atts, unit) {
      return { min: 0, max: 10 };
    },
    apCost: function (level, atts, unit) {
      return 45;
    },
    mpCost: function (level, atts, unit) {
      return level * 10;
    },
    potency: function (level, atts, unit) {
      return Math.round(40 + level * (atts.willpower / 2));
    },
  },

  mystic_focus: {
    range: function (level, atts, unit) {
      return { min: 0, max: 0 };
    },
    apCost: function (level, atts, unit) {
      return 80 - level;
    },
    potency: function (level, atts, unit) {
      return Math.round(50 + level * (atts.willpower / 5));
    },
  },
  iron_will: {
    range: function (level, atts, unit) {
      return { min: 0, max: 0 };
    },
    potency: function (level, atts, unit) {
      return level * 0.03;
    },
  },
  send_mana: {
    range: function (level, atts, unit) {
      return { min: 0, max: 1 + level / 2 };
    },
    apCost: function (level, atts, unit) {
      return 45;
    },
    mpCost: function (level, atts, unit) {
      return Math.round(Math.max((unit.max_mp * (30 - level)) / 100, 1));
    },
    potency: function (level, atts, unit) {
      return Math.round((unit.max_mp * (10 + level)) / 100);
    },
  },
  bless: {
    range: function (level, atts, unit) {
      return { min: 0, max: 10 };
    },
    apCost: function (level, atts, unit) {
      return 25;
    },
    mpCost: function (level, atts, unit) {
      return 30 + level * 3;
    },
    healing: function (level, atts, unit) {
      return Math.round(1 + level * (atts.willpower / 60 + atts.mana / 120));
    },
    potency: function (level, atts, unit) {
      return level * 2;
    },
    duration: function () {
      return 60000;
    },
  },
  sanctuary: {
    range: function (level, atts, unit) {
      return { min: 0, max: 1 + level / 2 };
    },
    apCost: function (level, atts, unit) {
      return 65;
    },
    mpCost: function (level, atts, unit) {
      return 40 + level * 6;
    },
    effectRange: function (level, atts, unit) {
      return 2;
    },
    healing: function (level, atts, unit) {
      return Math.round(level * (atts.willpower / 10));
    },
    duration: function (level, atts, unit) {
      return 15000;
    },
  },
  holy_force: {
    range: function (level, atts, unit) {
      return { min: 0, max: 0 };
    },
    apCost: function (level, atts, unit) {
      return 40 - level;
    },
    mpCost: function (level, atts, unit) {
      return 40 + level * 4;
    },
    effectRange: function (level, atts, unit) {
      return 2;
    },
    healing: function (level, atts, unit) {
      return Math.round(20 + level * (atts.willpower / 4 + atts.mana / 10));
    },
    potency: function (level, atts, unit) {
      return Math.floor(1 + level / 10);
    },
  },
};
module.exports = AbilityFuncs;
